import {charcoal} from '../sass/base/_exports.sass';

export const MobileDeviceIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {
    height: `${ratio * height}px`,
    width: `${ratio * width}px`,
  };

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M 9.332031 5.335938 L 9.332031 26.667969 L 22.667969 26.667969 L 22.667969 5.335938 Z M 8 2.667969 L 24 2.667969 C 24.355469 2.667969 24.691406 2.808594 24.941406 3.058594 C 25.191406 3.308594 25.332031 3.648438 25.332031 4 L 25.332031 28 C 25.332031 28.355469 25.191406 28.695312 24.941406 28.945312 C 24.691406 29.195312 24.355469 29.335938 24 29.335938 L 8 29.335938 C 7.648438 29.335938 7.308594 29.195312 7.058594 28.945312 C 6.808594 28.695312 6.667969 28.355469 6.667969 28 L 6.667969 4 C 6.667969 3.648438 6.808594 3.308594 7.058594 3.058594 C 7.308594 2.808594 7.648438 2.667969 8 2.667969 Z M 16 22.667969 C 16.355469 22.667969 16.691406 22.808594 16.941406 23.058594 C 17.191406 23.308594 17.332031 23.648438 17.332031 24 C 17.332031 24.355469 17.191406 24.695312 16.941406 24.945312 C 16.691406 25.195312 16.355469 25.335938 16 25.335938 C 15.648438 25.335938 15.308594 25.195312 15.058594 24.945312 C 14.808594 24.695312 14.667969 24.355469 14.667969 24 C 14.667969 23.648438 14.808594 23.308594 15.058594 23.058594 C 15.308594 22.808594 15.648438 22.667969 16 22.667969 Z M 16 22.667969"
          fill={color}
        />
      </g>
    </svg>
  );
};
